import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const HomeIcon = ({ size = 22, filled = false, ...props }: IconProps & { filled?: boolean }) => (
  <svg {...iconBaseProps(size, props)} fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 10l9-7 9 7v10a2 2 0 0 1-2 2h-4v-7H9v7H5a2 2 0 0 1-2-2V10z" />
  </svg>
)
